import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { BehaviorSubject } from 'rxjs';
import { Prefix } from '../phone-number/phone-number.component';
import { GetSysTablesTM_Request } from '../models/GetSysTablesTM_Request.model';
import { SysTableObj } from '../models/sysTableObj.model';

@Injectable()
export class SystemTablesService {
	params: GetSysTablesTM_Request;
	apiUri = environment.apiUri + "/TofesMashkanta";
	sysTables = ['1216', '1443', '1453', '1499', '1705', '1708',
		'1719', '2093', '2122', '1225' ];
	private tables;
	private tablesLoadesSubject = new BehaviorSubject<boolean>(false);

	constructor(private http: HttpClient) {
		this.getSysTable(this.sysTables)
			.then(t => {
				this.tables = t;
				this.tablesLoadesSubject.next(true);
			})
			.catch(t => console.log("error retrieving tables"));
	}

	private getSysTable(tables: string[]) {
		const url = `${this.apiUri}/getSystemTables`;
		this.params = { tableNames: tables };
		return this.http.post(url, this.params).toPromise();
	}

	private dataToSysTableObj(data, isOrdered = true): SysTableObj[] {
		let objects: SysTableObj[] = [];
		if(data){
			(Object.keys(data)).forEach(v => {
				objects.push({
					name: data[v],
					code: v
				})
			});

			if (isOrdered) {
				return objects.sort((a, b) => a.name.localeCompare(b.name));
			}
			else {
				return objects;
			}
		}
	}

	areSysTablesLoaded$() {
		return this.tablesLoadesSubject.asObservable();
	}

	getTable(tableNumber: string, isOrdered = true) {
		return this.dataToSysTableObj(this.tables[tableNumber], isOrdered);
	}
}


// WEBPACK FOOTER //
// ./src/app/services/system-tables.service.ts